module.exports = __webpack_public_path__ + "img/图.d97cabe4.webp";